var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-breadcrumb',{staticClass:"mb-6",attrs:{"items":[
      {
        title: '推单管理',
        url: '/tax/list',
      },
      {
        title: '支付设置',
        active: true,
      } ]}}),_c('div',{staticStyle:{"background-color":"white","border-radius":"5px","padding":"15px","display":"flex","align-items":"center","flex-wrap":"wrap"}},[_c('span',{staticStyle:{"margin-right":"20px"}},[_vm._v("支付方式 :")]),_vm._l((_vm.payOptions),function(item){return _c('vs-radio',{key:item.value,staticStyle:{"margin-right":"10px","height":"20px"},attrs:{"vs-value":item.value},model:{value:(_vm.paySetting),callback:function ($$v) {_vm.paySetting=$$v},expression:"paySetting"}},[_vm._v(_vm._s(item.name))])}),_c('vs-button',{staticStyle:{"margin-left":"10px"},attrs:{"size":"medium"},on:{"click":_vm.save}},[_vm._v("保存")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }